var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4050_3712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1868 53.2607C40.2076 51.6368 46.1785 47.272 49.9129 41.3543C50.3686 40.6323 49.565 39.7687 48.8126 40.1724C45.9417 41.7125 42.5343 42.6049 38.8794 42.6049C28.7491 42.6049 20.5169 35.7524 20.3472 27.245C20.2898 24.3703 22.0055 21.8287 24.4952 20.7663L24.4935 20.7651C23.0217 21.2803 21.3666 21.4933 20.0866 22.3807C15.2316 25.7461 12.2845 31.9732 12.754 37.5713C13.2096 43.0036 16.5315 49.3694 22.2774 52.2134C25.2823 53.7006 29.1586 53.4585 33.1868 53.2607Z",
    fill: "url(#paint0_linear_4050_3712)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9438 35.1352C34.7638 35.7993 36.771 36.1674 38.8803 36.1674C47.1458 36.1674 53.8462 30.5178 53.8465 23.5488C53.8465 9.73262 40.9602 0.124981 27.3353 0.00137155C12.4804 -0.133619 0.244682 11.871 0.109375 26.7259C0.109375 26.7259 3.82589 15.248 17.1018 15.248C26.0849 15.248 32.3656 20.5803 33.3973 24.6111C33.6734 25.3474 33.8251 26.1445 33.8251 26.9772C33.8251 28.7233 33.161 30.3143 32.0717 31.5116C30.9924 32.6977 31.4371 34.5855 32.9438 35.1352Z",
    fill: "url(#paint1_linear_4050_3712)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3965 24.6108C32.3649 20.58 28.9294 12.8123 17.7695 12.8123C0.609539 12.8123 0.108566 26.7256 0.108566 26.7256C-0.0281112 41.7399 12.1018 53.954 27.0845 53.954C29.1833 53.954 31.226 53.7142 33.1869 53.2607C11.4246 54.3294 9.18952 26.1222 24.4937 20.7651L24.4954 20.7663C25.2694 20.436 26.1173 20.2471 27.0111 20.2375C29.9324 20.2064 32.4302 22.0343 33.3965 24.6108Z",
    fill: "url(#paint2_linear_4050_3712)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4050_3712",
    x1: 12.7052,
    y1: 37.0869,
    x2: 50.0457,
    y2: 37.0869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00376F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004E99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4050_3712",
    x1: 11.1414,
    y1: 9.51398,
    x2: 42.3812,
    y2: 27.9938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D34F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4050_3712",
    x1: 14.0664,
    y1: 14.938,
    x2: 22.4813,
    y2: 53.5477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0016,
    stopColor: "#006393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0086DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006393"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4050_3712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.9542,
    height: 53.9542,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeIcon);
export default __webpack_public_path__ + "static/media/edge_icon.0b876fb250648590e07707dccf24a0c0.svg";
export { ForwardRef as ReactComponent };